export const PROJECTS = [
  {
    slug: "hdfc-bank-r-square",
    name: "HDFC Bank",
    type: "Commercial",
    area: "3,00,000 sq ft",
    location: "R Square, Andheri, Mumbai",
    scope: "Design+Build",
    highlight: true,
    desc: "Delivered as ARA Designs & Turnkey Electrical Engineers, this is the project that brought the two practices together. Completed on time, within budget and to the client's satisfaction, it showed what one integrated team could achieve; and it convinced us our collaboration could be solidified for many more projects together as ARA Turnkey.",
    img: "/projects/hdfc-dsc7013.webp",
    gallery: [
      "/projects/hdfc-dsc7013.webp",
      "/projects/hdfc-dsc8021.webp",
      "/projects/hdfc-dsc6485.webp",
      "/projects/hdfc-dsc7946.webp",
      "/projects/hdfc-dsc7265.webp",
      "/projects/hdfc-render-a.jpg",
      "/projects/hdfc-render-b.jpg",
    ],
  },
  {
    slug: "oleander-farms",
    name: "Oleander Farms",
    type: "Hospitality",
    area: "5,66,280 sq ft",
    location: "Karjat",
    scope: "Design + Build",
    img: "/projects/oleander-hero.webp",
    gallery: [
      "/projects/oleander-hero.webp",
      "/projects/oleander-room.jpg",
      "/projects/oleander-plan.webp",
    ],
  },
  {
    slug: "citi-bank",
    name: "Citi Bank",
    type: "Commercial",
    area: "1,20,000 sq ft",
    location: "EON, Kharadi, Pune",
    scope: "Electrical",
    img: "/projects/citi-4.webp",
    gallery: [
      "/projects/citi-4.webp",
      "/projects/citi-3.webp",
      "/projects/citi-1.webp",
      "/projects/citi-2.webp",
    ],
  },
  {
    slug: "dave-and-busters",
    name: "Dave & Buster's",
    type: "Hospitality",
    area: "14,000 sq ft",
    location: "Delhi",
    scope: "Design + Build",
    img: "/projects/dnb-picture1.jpg",
    gallery: [
      "/projects/dnb-picture1.jpg",
      "/projects/dnb-picture6.jpg",
      "/projects/dnb-brochure.webp",
    ],
  },
  {
    slug: "sterlight",
    name: "Sterlight",
    type: "Software Development Center",
    sector: "Commercial",
    area: "25,000 sq ft",
    location: "Pune",
    scope: "Electrical",
    img: "/projects/ster-1.webp",
    gallery: [
      "/projects/ster-1.webp",
      "/projects/ster-2.webp",
      "/projects/ster-3.webp",
      "/projects/ster-4.webp",
      "/projects/ster-5.webp",
    ],
  },
  {
    slug: "abel-boulevard",
    name: "Abel Boulevard",
    type: "Hospitality",
    area: "14,500 sq ft",
    location: "Pune",
    scope: "Design + Build",
    img: "/projects/abel-1.webp",
    gallery: [
      "/projects/abel-1.webp",
      "/projects/abel-2.webp",
      "/projects/abel-3.webp",
      "/projects/abel-4.webp",
      "/projects/abel-5.webp",
    ],
  },
  {
    slug: "western-union",
    name: "Western Union",
    type: "Commercial",
    area: "95,000 sq ft",
    location: "Pune",
    scope: "Electrical",
    img: "/projects/wu-1.webp",
    gallery: [
      "/projects/wu-1.webp",
      "/projects/wu-2.webp",
      "/projects/wu-3.webp",
    ],
  },
];
